import { IConnectBtcResponse, IInjectedBtcProvider } from '../../types';
import { getTomoBtcProvider } from './getTomoBtcProvider';

// https://docs.tomo.inc/tomo-wallet/extension-wallet/developer-manual/bitcoin-integration
const TOMO_ACCOUNT_CHANGE_EVENT = 'accountChanged';

export async function connectTomo(): Promise<IConnectBtcResponse> {
  const provider = getTomoBtcProvider();

  if (!provider) {
    throw new Error('Tomo BTC provider is not found');
  }

  const [address] = await provider.requestAccounts();
  const publicKey = await provider.getPublicKey();

  const injectedProvider: IInjectedBtcProvider = {
    onAccountChange: (callback: (address: string) => void) => {
      provider.on(TOMO_ACCOUNT_CHANGE_EVENT, callback);
    },
    removeAccountChangeListener: (callback: (args: any) => void) => {
      provider.removeListener(TOMO_ACCOUNT_CHANGE_EVENT, callback);
    },
  };

  return {
    address,
    publicKey,
    injectedProvider,
  };
}
